/* eslint-disable require-jsdoc */
export function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);

        if (!response.ok) {
            if (response.status === 400) {
                return Promise.reject(data);
            }
            if (response.status === 403) {
                window.location.reload();
                console.log('error', 'Access denied!');
            }
            if (response.status === 401) {
                window.location.reload();
                console.log('error', 'Section timeout');

            }
            if (response.status === 404) {
                window.location.replace('/error-404');
            }
            const error = (data && data.message) || response.statusText;

            return Promise.reject(error);
        }

        return data;
    });
}
